import 'bootstrap/dist/js/bootstrap.min.js';
import './style/spacelab.min.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';

import Header from './components/Header';
import JobPage from './components/JobPage';
import TaskPage from './components/TaskPage';
import HomePage from './components/HomePage';
import AboutPage from './components/AboutPage';
import JobDialog from './components/JobDialog';
import PlanDialog from './components/PlanDialog';
import LogInDialog from './components/LogInDialog';
import ErrorDialog from './components/ErrorDialog';
import ClusterPage from './components/ClusterPage';
import JobFilePage from './components/JobFilePage';
import JobReportPage from './components/JobReport';
import DirectiveDialog from './components/DirectiveDialog';
import ConfirmationDialog from './components/ConfirmationDialog';
import JobFileUploadDialog from './components/JobFileUploadDialog';
import JobWatchDialog from './components/JobWatchDialog';
import PrescriptionPage from './components/PrescriptionPage'
import MachinesPage from './components/MachinesPage'
import AdminPage from './components/AdminPage'
import EntraIdLogin from './components/EntraIdLogin';
import DssPage from './components/DssPage';

import gUtilities from './script/utilities';
import FileUploadDialog from './components/FileUploadDialog';

const styles = {
  routes: {
    margin: "5px", padding: "5px"

  }, container: {
    padding: 0
  }
}

function App() {
  const { accounts } = useMsal();

  useEffect(() => {
    gUtilities.verifyUrl();
  }, []);

  return (
    <div className="container-fluid" style={styles.container}>
      <Router>
        {accounts.length > 0 && (
          <header>
            <Header />
          </header>
        )}
        <JobDialog />
        <PlanDialog />
        <LogInDialog />
        <ErrorDialog />
        <FileUploadDialog />
        <JobFileUploadDialog />
        <DirectiveDialog />
        <ConfirmationDialog />
        <JobWatchDialog />
        <Routes>
          <Route exact path="/" element={<EntraIdLogin />} />
          <Route exact path="/home" element={<div style={styles.routes}><HomePage /></div>} />
          <Route exact path="/app/dss" element={<div style={styles.routes}><DssPage /></div>} />
          <Route exact path="/app/jobs" element={<div style={styles.routes}><JobPage /></div>} />
          <Route exact path="/app/tasks" element={<div style={styles.routes}><TaskPage /></div>} />
          <Route exact path="/app/about" element={<div style={styles.routes}><AboutPage /></div>} />
          <Route exact path="/app/admin" element={<div style={styles.routes}><AdminPage /></div>} />
          <Route exact path="/app/cluster" element={<div style={styles.routes}><ClusterPage /></div>} />
          <Route exact path="/app/machines" element={<div style={styles.routes}><MachinesPage /></div>} />
          <Route exact path="/app/job/file" element={<div style={styles.routes}><JobFilePage /></div>} />
          <Route exact path="/app/job/report" element={<div style={styles.routes}><JobReportPage /></div>} />
          <Route exact path="/app/prescription" element={<div style={styles.routes}><PrescriptionPage /></div>} />
        </Routes>
      </Router>
    </div >
  );
}

export default App;
